export interface CredentialsResponse {
  id: string;
  role: string;
  authToken: string;
  expiresIn: number;
};

export interface CredentialsRequest {
  email: string;
  password: string;
};

export interface UserResponse {
  id: string;
  email: string;
  accessType: string;
  phoneNumber: string;
};

export interface ClaimantResponse {
  id: number;
  identity: UserResponse;
  firstName: string;
  lastName: string;
  policyNumber: string;
  certificateNumber: string;
  relationshipType: RelationshipType;
  dateOfBirth: Date;
  gender: Gender;
  address: AddressResponse;
  preferredContactMethod: PreferredContactMethod;
  memberFirstName: string;
  memberLastName: string;
  addedByUser: UserResponse;
};

export interface ClaimantRequest {
  policyNumber: number;
  certificateNumber: string;
  memberFirstName: string;
  memberLastName: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  relationshipType: string;
  dateOfBirth: Date;
  address1: string;
  address2: string;
  city: string;
  postalCode: string;
  province: string;
  gender: string;
  phoneNumber: string;
  preferredMethodOfContact: string;
};

export interface ClaimantWithoutUserRequest {
  firstName: string;
  lastName: string;
  dateOfBirth: Date;
  gender: string;
  relationshipType: string;
};

export interface ClaimantByAdminRequest {
    policyNumber: number;
    certificateNumber: string;
    memberFirstName: string;
    memberLastName: string;
    firstName: string;
    lastName: string;
    relationshipType: string;
    dateOfBirth: Date;
    gender: string;
};


export interface AdministratorResponse {
  id: number;
  identity: UserResponse;
  firstName: string;
  lastName: string;
};

export interface AdministratorRequest {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  phoneNumber: string;
};

export interface AssessorResponse {
  id: number;
  identity: UserResponse;
  firstName: string;
  lastName: string;
};

export interface AssessorRequest {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  phoneNumber: string;
};

export interface EmployerResponse {
  id: number;
  insuranceCompanyId: number;
  insuranceCompany: InsuranceCompany;
  policyNumber: number;
  name: string;
  implementationDate: Date;
  terminationDate: Date;
  status: Status;
};

export interface EmployerRequest {
  insuranceCompanyId: number;
  policyNumber: number;
  name: string;
  implementationDate: Date;
  terminationDate?: Date;
}

export interface InsuranceCompany {
  id: number;
  name: string;
  status: Status;
};

export interface Prescriber {
  id: number;
  firstName: string;
  lastName: string;
  license: License;
  dateCreated: Date;
  dateUpdated: Date;
};

export interface DrugExceptionResponse {
  id: number;
  claimantId?: number;
  claimant?: ClaimantResponse;
  assessorId?: number;
  assessor?: AssessorResponse;
  documentType: string;
  drugExceptionStatus: string;
  submittedDate: Date;
  assignedDate: Date;
  dueDate: Date;
  expirationDate: Date;
  comment: string;
  medicalCondition: string;
  din: string;
  drugName: string;
  effectiveDate: Date;
  terminationDate: Date;
  reimbursementTierApproved: string;
  physicianName: string;
  physicianLicense: string;
  physicianFSA: string;
  adminNotes: string;
};

export interface DrugExceptionRequest {
  claimantId: number;
  documentType: string;
};

export interface DocumentResponse {
  id: number;
  fileName: string;
  drugException?: DrugExceptionResponse;
  drugExceptionId?: number;
}

export interface License {
  licenseType: string;
  licenseNumber: string;
};

export interface AddressResponse {
  address1: string;
  address2: string;
  city: string;
  postalCode: string;
  province: Province;
};

export enum AccessType {
  MEMBER_CLAIMANT_ACCESS,
  NON_MEMBER_CLAIMANT_ACCESS,
  ASSESSOR_ACCESS,
  ADMIN_ACCESS
}

export enum RelationshipType {
  MEMBER,
  DEPENDANT,
  SPOUSE
}

export enum PreferredContactMethod {
  PHONE,
  EMAIL
}

export enum Province {
  ON,
  QC,
  NS,
  NB,
  MB,
  BC,
  PE,
  SK,
  AB,
  NL,
  NT,
  YT,
  NU,
}

export enum DocumentType {
  PDF,
  JPG,
}

export enum DrugExceptionStatus {
  UNDER_REVIEW, // Admin needs to input details from form - member sees SUBMITTED
  INCOMPLETE, // Incomplete so sent back to member - member sees REJECTED
  APPROVED, // Admin has approved - ready to send to Insurance company - member sees APPROVED
  NOT_APPROVED, // Insurance company has declined (likley due to ineligibility) - member sees DECLINED
  EXPIRED, // 
  ASSESSED_APPROVED, //Assessor has approved the request but we�re waiting for the Canada Life process to complete - member sees UNDER REVIEW, admin and assessor see ASSESSED/APPROVED
  ASSESSED_NOT_APPROVED //Assessor has not approved the request but we�re waiting for the Canada Life process to complete - member sees UNDER REVIEW, admin and assessor see ASSESSED/DECLINED
}

export enum Gender {
  MALE,
  FEMALE,
  OTHER,
}

export enum Language {
  ENGLISH,
  FRENCH,
}

export enum Status {
  ACTIVE,
  INACTIVE
}

export interface InitialAdmin {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}
